var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelarus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M24 .012H.022v15.983H24V.012z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M0 10.783h23.97V.005H0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M4.688 10.783V.005H0v15.99h23.97H4.688v-5.212z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M3.217 7.423l-.87-1.575.87-1.553.863 1.553-.863 1.575zm-1.74 0l-.87-1.575.87-1.553.87 1.553-.87 1.575zm1.74 4.282l-.87-1.575.87-1.552.863 1.552-.863 1.575zm-1.74 0l-.87-1.575.87-1.552.87 1.552-.87 1.575zm1.74 4.29l-.87-1.582.87-1.546.863 1.545-.863 1.583zm-1.74 0l-.87-1.582.87-1.546.87 1.545-.87 1.583zm1.74-12.862l-.87-1.575.87-1.553.863 1.553-.863 1.574zm-1.74 0l-.87-1.575.87-1.553.87 1.553-.87 1.574z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelarus);
export default __webpack_public_path__ + "static/media/Belarus.e4e2b2150fd443213e90f1004a44e775.svg";
export { ForwardRef as ReactComponent };